import community from '@shared/middlewares/community';
import router from '@app/config/router';
import store from '@app/config/store';

export default community({ router, store });
